import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import NotificationWindow from 'components/NotificationWindow';
import {
  ERROR_SERVER_ERROR,
  GLOBAL_CHANGE_EMAIL_TOKEN_INVALID,
  GLOBAL_MESSAGES,
  SUCCESS_CHANGE_EMAIL_MESSAGE
} from 'utils/messages';

class VerifyChangeEmailPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      verifyMessage: 'Verifying email change...'
    };
  }

  componentDidMount() {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.token
    ) {
      let token = this.props.match.params.token;

      this.props
        .validateToken(token)
        .then(res => {
          if (res && res.data) {
            if (res.data.verifyChangeEmail) {
              this.setState({
                verifyMessage: SUCCESS_CHANGE_EMAIL_MESSAGE
              });
            } else {
              this.setState({
                verifyMessage:
                  GLOBAL_MESSAGES[GLOBAL_CHANGE_EMAIL_TOKEN_INVALID]
              });
            }
          } else {
            this.setState({
              verifyMessage: ERROR_SERVER_ERROR
            });
          }
        })
        .catch(() => {
          this.setState({
            verifyMessage: ERROR_SERVER_ERROR
          });
        });
    }
  }

  render() {
    return (
      <NotificationWindow message={this.state.verifyMessage} closeUrl="/" />
    );
  }
}

const VERIFY_CHANGE_EMAIL_MUTATION = gql`
  mutation MyVerifyChangeEmail($changeToken: String!) {
    verifyChangeEmail(changeToken: $changeToken) {
      verified
    }
  }
`;

const withVerifyChangeEmail = graphql(VERIFY_CHANGE_EMAIL_MUTATION, {
  props: ({ mutate }) => ({
    validateToken: changeToken => mutate({ variables: { changeToken } })
  }),
  options: {
    errorPolicy: 'all'
  }
});

export default withVerifyChangeEmail(VerifyChangeEmailPage);
